import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["animate", "className", "fixedWidth", "flip", "name", "pull", "rotate", "size", "stacked", "type"],
    _excluded2 = ["children", "className", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import cn from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
var typeMapping = {
  solid: 'fas',
  regular: 'far',
  light: 'fal',
  duoTone: 'fad',
  brand: 'fab'
};
/**
 * Renders an `i` element with the given props which FontAwesome uses
 * to render an icon.
 *
 * @author Tom Milewski
 *
 * @see {@link https://fontawesome.com/cheatsheet/pro FontAwesome icon reference}
 *
 * @example
 * // Defaults to `type="solid"`
 * <Icon name="link" />
 *
 * @example
 * <Icon
 *    name="link"
 *    type="regular"
 *    size="2xl"
 *    fixedWidth
 *    rotate={90}
 *    flip="horizontal"
 *    className="clickable"
 *    onClick={() => null}
 *  />
 */

export var Icon = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var animate = _ref.animate,
      className = _ref.className,
      fixedWidth = _ref.fixedWidth,
      flip = _ref.flip,
      name = _ref.name,
      pull = _ref.pull,
      rotate = _ref.rotate,
      size = _ref.size,
      stacked = _ref.stacked,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (flip && rotate) {
    throw new Error('Cannot use the mirror and rotate props at the same time');
  }

  var computedSize = stacked && size ? "stack-".concat(size) : size;
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    "aria-hidden": true,
    as: "i",
    className: cn("fa-".concat(name), _defineProperty({}, "fa-".concat(animate), animate), _defineProperty({}, "fa-fw", fixedWidth), _defineProperty({}, "fa-flip-".concat(flip), flip), _defineProperty({}, "fa-pull-".concat(pull), pull), _defineProperty({}, "fa-rotate-".concat(rotate), rotate), _defineProperty({}, "fa-".concat(computedSize), computedSize), typeMapping[type !== null && type !== void 0 ? type : 'solid'], className)
  }, rest), {}, {
    ref: forwardedRef
  }));
}); // Set to span as `i` isn't a valid tag

/**
 * Renders an `span` element with the given props which FontAwesome uses
 * to render stacked icons. It inherits from `HTMLSpanElement`.
 *
 * @author Tom Milewski
 *
 * @example
 *  <IconStack size="2x">
 *    <Icon name="camera" size="1x" />
 *    <Icon name="ban" size="2x" style="color:Tomato" />
 *  </IconStack>
 */

export var IconStack = /*#__PURE__*/React.forwardRef(function (_ref2, forwardedRef) {
  var children = _ref2.children,
      className = _ref2.className,
      size = _ref2.size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  if (React.Children.count(children) !== 2) {
    throw new Error('You may only stack two <Icon> components');
  }

  var stackedChildren = React.Children.map(children, function (child) {
    var item = child;
    return /*#__PURE__*/React.cloneElement(item, _objectSpread({
      stacked: true
    }, item.props));
  });
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({
    className: cn("fa-stack", _defineProperty({}, "fa-".concat(size), size), className)
  }, rest), {}, {
    ref: forwardedRef,
    children: stackedChildren
  }));
});